__webpack_require__.p = "https://asset-test-wl2.api-victory.com/";